"use client";

import { FC } from "react";
import styles from "./app-wide-loader.module.css";

interface AppWideLoaderProps {
  text?: string;
}

export const AppWideLoader: FC<AppWideLoaderProps> = ({
  text = "Loading...",
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <span className="loading loading-ring loading-xl"></span>
      <p className="mt-4 text-lg font-light text-center">{text}</p>
    </div>
  );
};
